import React, { CSSProperties, FC } from 'react'
import type { WidgetProgressBarProps } from './widget-progress-bar.d'
import styles from './widget-progress-bar.module.scss'

export const WidgetProgressBar: FC<WidgetProgressBarProps> = ({
  borderColor = '#12C75D',
  backgroundColor = '#12C75D',
  containerBackgroundColor = '#E7EDEF',
  completionPercentage = 100,
}) => {
  const containerClass: CSSProperties = {
    borderRadius: '10px',
    background: containerBackgroundColor,
    border: `1px solid ${containerBackgroundColor}`,
    width: '100%',
  }

  const fillClass: CSSProperties = {
    borderRadius: completionPercentage === 100 ? '10px' : '10px 0px 0px 10px',
    background: backgroundColor,
    border: completionPercentage > 0 ? `1px solid ${borderColor}` : '',
    width: `${completionPercentage}%`,
    position: 'absolute',
    top: '0',
    left: '0',
  }

  return (
    <div style={{ position: 'relative' }}>
      <div className={styles['root']} style={containerClass}></div>
      <div className={styles['root']} style={fillClass}></div>
    </div>
  )
}
